// Shared by the browser converter and the offline Excel-template builder.
export const EXCEL_SHEETS = {
    样本配对: { headers: ['匿名样本编号', '位点1', '基因型1', '位点2', '基因型2'], required: 5, rows: 20001 },
};
export const EXCEL_TEMPLATE_URL = '/rgnet-assets/rgnet-multigene-pairs-template.xlsx';
export const diseaseName = network => network?.cohort?.name || network?.datasetName || '';
